$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

function updateBalance()
{
    $.get({
        url: '/user/balance',
        success: function (data) {
            if(data.balance) $('#sidebar_balance').html(data.balance);
        },
    });
}

/**
 * Tasks
 */
let taskStart = false;
$('body').on("click", "a[data-bind='taskAction']", function(e) {
    e.preventDefault();
    if(taskStart) {
        console.error('Blocked ajax');
        return;
    }
    taskStart = true;

    let doTask = false;
    let el = this;
    $(el).addClass('disabled');
    let url = $(el).data("href");
    let id = $(el).data('taskId');
    let type = $(el).data('taskType');
    let method = $(el).data('taskMethod');
    $.get({
        url: url,
        success: function (data) {
            if (data.status === 'success') {
                doTask = true;

                if(method === 'skip') {
                    $('#task-' + type + '-' + id).remove();
                } else {
                    $('#task-' + type + '-' + id).find('a.btn-do-task').addClass('disabled').text('задание выполнено');
                }

                let message = data.msg ? data.msg : 'Действие выполнено успешно';
                noti(data.status, message);
            } else {
                noti(data.status, data.msg);
            }
            updateBalance();
        }, complete: function() {
            taskStart = false;
            if(!doTask) $(el).removeClass('disabled');
        }
    });
});

$('body').on("click", "a[data-bind='goToTask']", function(e) {
    e.preventDefault();
    let btn  = this;
    let id   = $(btn).data('taskId');
    let type = $(btn).data('taskType');
    let href = $(btn).attr('href');

    let w = window.open();
    w.document.write('<meta http-equiv="refresh" content="0;url=' + href + '">');
    w.document.close();

    /**
     * Скрытие кнопки перехода и вывод кнопки подтверждения
     */
    $('#task-'+ type +'-' + id).find('.btn-go-to-task').hide();
    $('#task-'+ type +'-' + id).find('.btn-do-task').show();
});

/**
 * Tasks Ajax Load Pages
 **/
$('body').on("click", "a[data-nav='tasksAjax']", function(e) {
    e.preventDefault();

    let el  = $(this);
    let url = el.attr('href');
    $.get({
        url: url,
        success: function(data) {
            $('.sidebar__menu').find('.active').removeClass('active');
            el.parent().addClass('active');
            $('.cabinet__main__wrap').html(data);
            history.pushState({}, '', url);
        },
        error: function(xhr, textStatus, error) {
            if(error === 'Unauthorized') {
                document.location.href = url;
            }
        }
    });
});


/**
 * Orders
 */
(function() {
    /** Folders **/
    $('body').on("click", "a[data-bind='addFolder']", function (e) {
        e.preventDefault();
        let actionUrl = $(this).data('href');
        let newBtnUrl = $(this).data('btn-url');
        let folderName = prompt('Введите имя папки', 'Новая папка');
        if(folderName === null) return false;

        $.post({
            url: actionUrl,
            data: {'name':folderName},
            success: function(data) {
                if(data.status === 'success') {
                    let btn = '<a href="'+ newBtnUrl + data.data.item.id + '" class="btn btn-sm btn-outline-primary mb-3">'+ folderName +'</a>';
                    $('#folders-list').append(btn);
                }
            },
            error: function(xhr, textStatus, error) {
                noti('error', 'Error');
            },
        });
    });

    /** Действия с заказами **/
    $('body').on("click", "a[data-bind='orderAction']", function(e) {
        e.preventDefault();
        let orderId = $(this).data('orderId');
        let actionUrl = this.href;
        let action = $(this).data('action');
        $.get({
            url: actionUrl,
            success: function(data) {
                noti(data.status, data.msg);

                if(data.status === 'success' && action === 'archive') {
                    $('.order-block-id-' + orderId).remove();
                }
            },
        });
    });

    /**
     * Скрыть\открыть таргетинг для мобайл
     */
    $('#toggleTargeting').on('click', function(e){
        e.preventDefault();
        $('#targeting').slideToggle(500);
    });

    /**
     * Регулятор лимита
     */
    $('input#limit_order').on('change, input', function(){
        $(this).next('small').children('span').text(this.value);
    });

    /** Prices **/
    $('#count_order').on('input', changeOrderPrice);
    $('#type_order').on('change', changeOrderPrice);

    function changeOrderPrice()
    {
        let countInput = $('#count_order');
        let price = countInput.data('price');
        let count = parseInt($(countInput).val());

        //if this vk likes page
        let isReposts = $('#type_order').val();
        if( isReposts ) {
            if( isReposts === "1" ) {
                price = countInput.data('price-1');
            } else {
                price = countInput.data('price-0');
            }
        }

        //change input price
        if( isNaN(count) || count < 10 ) {
            count = 10;
        }

        $('#order-price').val( (count*price).toFixed(2) );
    }

})();



/**
 * Select box change display block|none for another elements
 * data-bind="change-select"
 * data-bind-items="pay-system" -> data-item="pay-system" data-item-id="1"
 */
$('body').on("change", 'select[data-bind="change-select"]', function(e) {
    bindItem = $(this).data('bindItems');
    bindId = this.value;
    $('[data-item="' + bindItem + '"]').hide();
    $('[data-item="' + bindItem + '"][data-item-id="' + bindId + '"]').show();
});
/** Select box end **/

/** Wallets reset in withdraws **/
$('body').on("click", 'a.account_settings__reset_wallet', function(e) {
    e.preventDefault();
    let walletIcon = this;
    let walletInput = $(walletIcon).prev('input');

    $.ajax({
        'method': 'DELETE',
        'url': $(this).attr('href'),
        'success': function (data) {
            if (data.status == 'success') {
                $(walletIcon).hide();
                $(walletInput).removeAttr('disabled').val('');
            }
            noti('error', data.message);
        },
    });
});
/** Wallets reset in withdraws end **/

/**
 * Payment forms
 */
//payment-form yandex cards
$('body').on('click', '[data-bind="toggle-payment-form"]', function (e) {
    e.preventDefault();

    $('.payment-btn a').removeClass('active');
    $(this).addClass('active');

    let forms = $('.payment-form');
    let type  = $(this).data('type');
    let form  = $('.payment-form.' + type);

    if (type === 'yandex') {
        $('#yandex-payment-type').val('PC');
        addComission(0.5);
    }
    if (type === 'cards') {
        $('#yandex-payment-type').val('AC');
        addComission(2);
    }

    $(forms).hide();
    $(form).show();
});
/** for QIWI **/
$('body').on('click', '#payment-qiwi-link', function () {
    let amount = $('#payment-qiwi-amount').val();
    //let phone = $('#payment-qiwi-wallet').val();

    $.ajax({
        'method': 'POST',
        'url': '/account/payments/make/qiwi/' + amount,
        'success': function (data) {
            if (data.status === 'success') {
                $('#qiwi-go-to-pay').attr('href', data.data.url).click();
                $('.qiwi_step_1').hide(0, function () {
                    $('.qiwi_step_2').show();
                });
            } else {
                noti('error', data.msg);
            }
        },
    });
});
/** for QIWI end **/

/** for Coinbase **/
$('body').on('click', '#payment-coinbase-link', function () {
    let amount = $('#payment-coinbase-amount').val();
    //let phone = $('#payment-qiwi-wallet').val();

    $.ajax({
        'method': 'POST',
        'url': '/account/payments/make/coinbase/' + amount,
        'success': function (data) {
            if (data.status === 'success') {
                $('#coinbase-go-to-pay').attr('href', data.data.url).click();
                $('.coinbase_step_1').hide(0, function () {
                    $('.coinbase_step_2').show();
                });
            } else {
                noti('error', data.msg);
            }
        },
    });
});
/** for Coinbase end **/

/** for Payeer **/
$('body').on('click', 'button#payeer-makeSign', function () {
    let amount = $('#payment-payeer-amount').val();
    $.ajax({
        'method': 'POST',
        'url': '/account/payments/make/payeer/' + amount,
        'success': function (resp) {
            if (resp.status === 'success') {
                $('#payeer-sign').val(resp.data.m_sign);
                $('#payeer-orderid').val(resp.data.m_orderid);
                $('#payeer-amount').val(resp.data.m_amount);

                $('.payeer_step_1').hide(0, function () {
                    $('.payeer_step_2').show();
                });

                $('#payeer-go-to-pay').click();
            } else {
                noti('error', resp.msg);
            }
        },
    });
});
/** for Payeer end **/

/** for yandex **/
$("body").on("input", "#yandex-pre-amount", function () {
    let method = $("#yandex-payment-type").val();
    if (method === 'PC') {
        addComission(1);
    } else {
        addComission(3);
    }
});

function addComission(percent) {
    let amount = $("#yandex-pre-amount").val();
    let new_amount = (amount * 100 / (100 - percent)).toFixed(2);
    $("#yandex-amount").val(new_amount);
}
/** for yandex end **/

/** for ENOT **/
$('body').on('click', '#payment-enot-link', function () {
    let amount = $('#payment-enot-amount').val();

    $.ajax({
        'method': 'POST',
        'url': '/account/payments/make/enot/' + amount,
        'success': function (data) {
            if (data.status === 'success') {
                $('#enot-go-to-pay').attr('href', data.data.url).click();
                $('.enot_step_1').hide(0, function () {
                    $('.enot_step_2').show();
                });
            } else {
                noti('error', data.msg);
            }
        },
    });
});
/** for ENOT end **/

/** for Lava **/
$('body').on('click', '#payment-lava-link', function () {
    let amount = $('#payment-lava-amount').val();

    $.ajax({
        'method': 'POST',
        'url': '/account/payments/make/lava/' + amount,
        'success': function (data) {
            if (data.status === 'success') {
                $('#lava-go-to-pay').attr('href', data.data.url).click();
                $('.lava_step_1').hide(0, function () {
                    $('.lava_step_2').show();
                });
            } else {
                noti('error', data.msg);
            }
        },
    });
});
/** for Lava end **/

/** for ALL **/
$('button[data-add-money]').on('click', function () {
    let payment_system = $(this).data('add-money');
    console.log(payment_system);
    let amount = $(`#payment-${payment_system}-amount`).val();

    $.ajax({
        'method': 'POST',
        'url': `/account/payments/make/${payment_system}/${amount}`,
        'success': function (data) {
            if (data.status === 'success') {
                $(`#${payment_system}-go-to-pay`).attr('href', data.data.url).click();
                $(`.${payment_system}_step_1`).hide(0, function () {
                    $(`.${payment_system}_step_2`).show();
                });
            } else {
                noti('error', data.msg);
            }
        },
    });
});
/** for ALL end **/



/** Ajax pagination **/
$(document).ready(function () {
    $(document).on('click', '.pagination a', function (event) {
        event.preventDefault();

        $('.pagination li').removeClass('active');
        $(this).parent('li').addClass('active');

        let url = $(this).attr('href');
        //let page  = $(this).attr('href').split('page=')[1];

        getAjaxData(url);
    });
});

function getAjaxData(url) {
    $.ajax({
        url: url,
        type: "get",
        datatype: "html"
    }).done(function (data) {
        history.pushState(null, null, url);
        $("#ajax-container").empty().html(data);
        //location.hash = 'page=' + page;
    }).fail(function (jqXHR, ajaxOptions, thrownError) {
        noti('error', 'No response from server');
    });
}
/** Ajax pagination end **/


/** Ajax response for any element **/
$('body').on('click', '[data-request="ajax"]', function(e) {
    e.preventDefault();

    const el = $(this);

    let method = 'GET';
    if( $(el).data('method') ) method = $(el).data('method');

    let url = '';
    if( $(el).attr('href') ) url = $(el).attr('href');
    if( $(el).data('url') )  url = $(el).data('url');

    if( $(el).data('loader') ) {
        $(el).attr('disabled', 'true');
    }

    $.ajax({
        method : method,
        url    : url,
        data   : {
            'code' : $('#user-code').val()
        },
        success: function (data) {
            if (data.status === 'success') {
                window.location.href = '/account/phone/success';
            } else {
                noti('error', data.msg);
            }
        },
        complete: function() {
            $(el).attr('disabled', false);
        }
    });
});
/** END Ajax response for any element **/



/**
 * Notifications
 **/
function noti(type, msg) {
    type == 'success' ? title = 'Успешно выполнено' : title = 'Ошибка выполнения';
    $.notify({
        title: title,
        message: msg,
    }, {
        type: 'noti-' + type,
        allow_dismiss: false,
    });
}
/**
 * End Notifications
 **/
